var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-layout-content",
    { staticClass: "custom-layout-content" },
    [
      _c(
        "a-row",
        {
          staticStyle: { height: "100vh" },
          attrs: { type: "flex", justify: "center" }
        },
        [
          _c(
            "a-card",
            { staticClass: "custom-card-container" },
            [
              _c("div", { staticClass: "custom-card-title" }, [
                _vm._v(" " + _vm._s(_vm.$t("lbl_forgot_password_title")) + " ")
              ]),
              _c("div", { staticClass: "custom-card-description" }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("lbl_forgot_password_description")) + " "
                )
              ]),
              _c(
                "a-form",
                {
                  attrs: { form: _vm.form, layout: "vertical" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.submitForm.apply(null, arguments)
                    }
                  }
                },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: _vm.$t(_vm.formRules.username.label),
                        hasFeedback: true
                      }
                    },
                    [
                      _c(
                        "a-input",
                        {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: _vm.formRules.username.decorator,
                              expression: "formRules.username.decorator"
                            }
                          ],
                          attrs: {
                            name: _vm.formRules.username.name,
                            placeholder: _vm.$t(
                              _vm.formRules.username.placeholder
                            ),
                            autocomplete: "off"
                          }
                        },
                        [
                          _c("a-icon", {
                            staticStyle: { color: "rgba(0, 0, 0, 0.25)" },
                            attrs: { slot: "prefix", type: "user" },
                            slot: "prefix"
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-button",
                    {
                      staticClass: "submit-button",
                      attrs: {
                        type: "primary",
                        "html-type": "submit",
                        loading: _vm.isFormSubmitted
                      }
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.$t("lbl_reset")) + " "),
                      _c("em", { staticClass: "fas fa-sign-in-alt ml-1" })
                    ]
                  ),
                  _c(
                    "label",
                    { staticClass: "footer-card" },
                    [
                      _c("i18n", {
                        attrs: { path: "lbl_have_account" },
                        scopedSlots: _vm._u([
                          {
                            key: "route",
                            fn: function() {
                              return [
                                _c(
                                  "router-link",
                                  { attrs: { to: "./signin" } },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("lbl_signin")) + " "
                                    )
                                  ]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }